import { combineReducers } from 'redux'
import { reducer as auth } from './auth'
import { reducer as getAllUsers } from './usersAll'

export default combineReducers({
  auth,
  getAllUsers
})
